import { defineMessages } from 'react-intl';

const physicalCardDetailMessages = defineMessages({
    fullNameLabel: {
        id: 'address.PhysicalCardMessage.fullNameLabel',
        description: 'Label for a full name field on an address form.',
        defaultMessage: 'Full Name'
    },
    countryLabel: {
        id: 'address.PhysicalCardMessage.countryLabel',
        description: 'Label for a country field on an address form',
        defaultMessage: 'Country'
    },
    streetLabel: {
        id: 'address.PhysicalCardMessage.street1Label',
        description: 'Label for an address 1 field on an address form',
        defaultMessage: 'Street Address'
    },
    apartmentLabel: {
        id: 'address.PhysicalCardMessage.street2Label',
        description: 'Label for an address 2 field on an address form',
        defaultMessage: 'Apt Suite Etc (optional)'
    },
    cityLabel: {
        id: 'address.PhysicalCardMessage.cityLabel',
        description: 'Label for a city field on an address form',
        defaultMessage: 'City'
    },
    stateLabel: {
        id: 'address.PhysicalCardMessage.stateLabel',
        description: 'Label for a state field on an address form',
        defaultMessage: 'State'
    },
    postalCodeLabel: {
        id: 'address.PhysicalCardMessage.phoneNumberLabel',
        description: 'Label for a ZIP code field on an address form',
        defaultMessage: 'ZIP code'
    },
    fullNameRequired: {
        id: 'address.PhysicalCardMessage.fullNameRequired',
        description:
            'Error message displayed when the full name was not provided on an address form',
        defaultMessage:
            'Enter your full name as it appears on your credit card'
    },
    street1Required: {
        id: 'address.PhysicalCardMessage.street1Required',
        description:
            'Error message displayed when the street address was not provided on an address form',
        defaultMessage: 'Enter your billing address'
    },
    cityRequired: {
        id: 'address.PhysicalCardMessage.cityRequired',
        description:
            'Error message displayed when the city was not provided on an address form',
        defaultMessage: 'Enter your billing city'
    },
    stateRequired: {
        id: 'address.PhysicalCardMessage.stateRequired',
        description:
            'Error message displayed when the state or province was not provided on an address form',
        defaultMessage: 'Select your billing State or Province'
    },
    postalCodeInvalid: {
        id: 'address.PhysicalCardMessage.postcodeInvalid',
        description:
            'Error message displayed when an invalid postal or zip code was provided on an address form',
        defaultMessage: 'Enter a valid ZIP code'
    },
    usePreviousAddress: {
        id: 'address.PhysicalCardMessage.usePreviousAddress',
        description:
            'Label for toggle to reuse an address that was previously entered',
        defaultMessage: 'Use Previous Address?'
    },
    recipientEmail: {
        id: 'address.PhysicalCardMessage.recipientEmail',
        description: 'Label for a recipientEmail field',
        defaultMessage: 'Recipient email'
    },
    maximumPhysicalCards: {
        id: 'cart.cartMessages.maximumPhysicalCards',
        description: 'Text shown at the top of cart page when the cart has reached the maximum amount of physical cards',
        defaultMessage: 'You have reached the limit of {maximumPhysicalCards} physical cards per order and cannot add more. However, you can still purchase digital cards.'
    },
    physicalCardLimit: {
        id: 'physicalCard.PhysicalCardMessage.physicalCardLimit',
        description: 'physicalCardLimit alert text',
        defaultMessage: 'Physical card limit reached'
    },
    physicalCardLimitSubHeading: {
        id: 'physicalCard.PhysicalCardMessage.physicalCardLimitSubHeading',
        description: 'physicalCardLimitSubHeading alert sub text',
        defaultMessage: ' You have already added the maximum of {cartMaxNumPlasticCards} physical cards to your cart. To add more, please choose digital gift cards.'
    }
});

export default physicalCardDetailMessages;
